import { VENUE_OWNER_ROLE, ATHLETE_ROLE, NO_ROLE, STAFF_ROLE, ADMIN_ROLE } from "../constants/roles";

export const getRole = (roles: string[]) => {
  // Admin is a platform-level role; it takes precedence and short-circuits so
  // admins are never treated as a conflicting owner/athlete combination.
  if (roles.includes(ADMIN_ROLE)) return ADMIN_ROLE;

  if (roles.includes(VENUE_OWNER_ROLE) && roles.includes(ATHLETE_ROLE)) {
    // TODO: handle this better
    throw Error("User has conflicting roles");
  }

  if (roles.includes(VENUE_OWNER_ROLE)) return VENUE_OWNER_ROLE;
  if (roles.includes(ATHLETE_ROLE)) return ATHLETE_ROLE;
  if (roles.includes(STAFF_ROLE)) return STAFF_ROLE;

  return NO_ROLE;
};
